module.exports = __webpack_public_path__ + "img/fig_rosalee_el.2dc7a7f5.png";